<template>
    <section class="main-visual">
        <video src="/videos/main-visual.mp4" autoplay muted preload loop class="main-visual__video" />
        <v-container>
            <v-row class="row--xl">
                <v-col cols="12">
                    <v-img src="/images/main/visual/main-visual-logo.svg" alt="REBORN BIOME" class="main-visual__logo" />
                </v-col>
                <v-col cols="12" class="text-center white--text">
                    <div class="tit mb-3 mb-md-4">20년 노하우로 만든 건강, 리본바이옴</div>
                    <v-row class="row--xs txt txt--lg white--text">
                        <v-col cols="12">리본바이옴은 20년간 인류의 장 건강을 연구해온 프로바이오틱스 전문 브랜드입니다.</v-col>
                        <v-col cols="12">엄격한 품질기준과 최신 과학으로 건강한 삶의 가치를 전합니다. (주)리본바이옴은 20년 전통의 프로바이오틱스 전문 제조사 ‘㈜웰빙엘에스’의 공식 판매·유통 자회사입니다.</v-col>
                        <v-col cols="12">리본바이옴 사이트에서 제공되는 모든 제품은 웰빙엘에스가 연구·제조한 정품이며, 리본바이옴은 온•오프라인 유통과 파트너 서비스를 담당합니다</v-col>
                    </v-row>
                </v-col>
            </v-row>
            <div class="btn-wrap btn-wrap--lg d-flex justify-center">
                <v-btn to="/about" color="primary" rounded x-large class="w-md-160px">브랜드 이야기</v-btn>
            </div>
        </v-container>
    </section>
    <!-- <section class="main-visual" v-if="banner">
        <swiper class="swiper" v-bind="{ options }">
            <swiper-slide v-for="(slide, index) in banner?.slides" :key="index">
                <v-card tile :to="slide?.isOuterLink ? undefined : slide?.url || undefined" :href="slide?.isOuterLink ? slide?.url || undefined : undefined" :target="slide?.target" class="main-visual__inner">
                    <div class="main-visual__img" :style="`background-image:url(${slide?.image});`">
                        <span class="d-sr-only">{{ slide?.meta?.title }}</span>
                    </div>
                </v-card>
            </swiper-slide>
            <div class="swiper-control">
                <div class="swiper-pagination" slot="pagination"></div>
            </div>
        </swiper>
    </section> -->
</template>

<script>
import api from "@/api";
import detect from "@/plugins/detect";

import { Swiper, SwiperSlide } from "vue-awesome-swiper";

const options = {
    effect: "fade",
    allowTouchMove: true,
    centeredSlides: true,
    spaceBetween: 0,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    speed: 500,
    loop: true,
    pagination: {
        el: ".main-visual .swiper-pagination",
        clickable: true,
    },
};

export default {
    components: {
        Swiper,
        SwiperSlide,
    },
    props: {
        code: { type: String, default: null },
    },
    data: () => ({
        banner: null,

        detect,
        options,
    }),
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            const { code } = this;
            const { banner } = await api.v1.banners.get({ code });
            console.log({ code, banner });
            this.banner = banner;
        },
        dynamicComponent(url) {
            return (url || "").indexOf("/") == 0 ? "router-link" : "a";
        },
    },
};
</script>

<style lang="scss" scoped>
// main-visual
.main-visual {
    position: relative;
    overflow: hidden;
    height: calc(100vh - var(--header-height));
    max-height: 1080px;
    display: flex;
    align-items: center;
    &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
    }
    &__video {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: block;
        pointer-events: none;
        min-height: 100%;
    }
    .container {
        position: relative;
        margin: auto;
        padding-top: 80px;
        padding-bottom: 80px;
        z-index: 10;
    }
    &__logo {
        max-width: 384px;
        margin: 0 auto;
        width: 200px;
    }
}
@media (min-width: 1024px) {
    .main-visual {
        min-height: 980px;
        &__video {
            // width: 100%;
            min-width: 100%;
            min-height: initial;
        }
        &__logo {
            width: 384px;
        }
    }
}
</style>
